import { memo } from "react";
import { Link, LinkProps } from "react-router-dom";

import omit from "lodash/omit";
import styled from "styled-components";

import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import { classIf } from "utility/style";

// -----------------------------------------------------------------------------

const SidebarButton = memo(function SidebarButton(
  props: SidebarButtonProps
): JSX.Element {
  const { label, Icon, topLevel, external } = props;
  const LinkComponent: any = external
    ? ListItemButtonAnchor
    : ListItemButtonLink;
  const linkProps = external
    ? {
        ...omit(props, "to", "label", "Icon", "topLevel", "external"),
        href: props.to,
      }
    : omit(props, "label", "Icon", "topLevel", "external");

  //
  return (
    <LinkComponent {...linkProps} className={classIf(topLevel, "topLevel")}>
      <ListItemButton>
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
        <ListItemText primary={label} />
      </ListItemButton>
    </LinkComponent>
  );
});

export default SidebarButton;

// -----------------------------------------------------------------------------

const ListItemButtonLink = styled(Link)`
  align-items: center;
  color: #000;
  display: block;
  min-height: 0vw;
  padding-left: clamp(4px, calc(0.25rem + ((1vw - 8px) * 3)), 16px);
  text-decoration: none;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .MuiListItemIcon-root {
    min-width: 32px;
    width: 32px;
  }

  .MuiListItemButton-root {
    height: 48px;

    svg {
      opacity: 0.5;
    }
  }

  &.topLevel {
    padding-left: 0;

    .MuiListItemButton-root svg {
      opacity: 1;
    }
  }
`;

const ListItemButtonAnchor = styled.a`
  align-items: center;
  color: #000;
  display: block;
  min-height: 0vw;
  padding-left: clamp(4px, calc(0.25rem + ((1vw - 8px) * 3)), 16px);
  text-decoration: none;

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .MuiListItemIcon-root {
    min-width: 32px;
    width: 32px;
  }

  .MuiListItemButton-root {
    height: 48px;

    svg {
      opacity: 0.5;
    }
  }

  &.topLevel {
    padding-left: 0;

    .MuiListItemButton-root svg {
      opacity: 1;
    }
  }
`;

// -----------------------------------------------------------------------------

interface SidebarButtonProps extends LinkProps {
  label: string;
  Icon: React.ElementType;
  topLevel?: boolean;
  external?: boolean;
}
